import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import 'babel-polyfill'

import fullCalendar from './components/customComponents/fullCalendar'
import EleMultiCascader from './components/customComponents/multiCascader'
import excelImportor from './components/customComponents/excelImportor'
import selectImportor from './components/customComponents/selectImportor'
import ElementUI from 'element-ui'
import router from './router'
import 'font-awesome/css/font-awesome.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'


Vue.component('fullCalendar', fullCalendar)
Vue.component('excelImportor', excelImportor)
Vue.component('selectImportor', selectImportor)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(preview)
Vue.use(EleMultiCascader)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js